import React from 'react';
import styles from './index.module.css';

const CheckIcon = ({ size = 12 }) => (
  <svg viewBox='0 0 16 16' width={size} height={size} aria-hidden='true'>
    <path
      d='M3.5 8.5l3 3 6-6.5'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CHECKLIST_STATES = ['pending', 'active', 'done'];

const ChecklistItem = ({ children, icon, state = 'pending', className }) => {
  const safeState = CHECKLIST_STATES.includes(state) ? state : 'pending';
  const classes = [styles.root, styles[safeState], className].filter(Boolean).join(' ');
  return (
    <li className={classes} aria-current={safeState === 'active' ? 'step' : undefined}>
      <span className={styles.iconDisc}>{icon || <CheckIcon />}</span>
      <span className={styles.label}>{children}</span>
      {safeState === 'done' && (
        <span className={styles.doneCheck} aria-label='Complete'>
          <CheckIcon size={14} />
        </span>
      )}
    </li>
  );
};

export default ChecklistItem;
